import { ZapTemplates } from '../components';

const asyncRoutes = {
  doesRequireServerApp: false,
  routes: {
    '.': {
      component: ZapTemplates,
      isAuthRequired: true,
    },
    ':status': {
      component: ZapTemplates,
      isAuthRequired: true,
    },
  },
};

export default asyncRoutes;
